import { gql } from "@apollo/client";

export const SYSTEM_MESSAGES = gql`
  query getSystemMessage($first: Int, $offset: Int) {
    allSystemMessages(
      first: $first
      offset: $offset
      orderBy: UPDATED_AT_DESC
      filter: { deletedAt: { isNull: true } }
    ) {
      nodes {
        categories
        createdAt
        deletedAt
        description
        documentLink
        documentType
        heading
        id
        messageId
        priority
        title
        type
        updatedAt
        feedsBySmId(filter: { userFeedsByFIdExist: false }) {
          nodes {
            fId
          }
        }
      }
      totalCount
    }
  }
`;

export const SYSTEM_MESSAGES_TOTAL_COUNT = gql`
  query notifyUser {
    allSystemMessages(
      filter: {
        and: {
          deletedAt: { isNull: true }
          feedBySmId: { userFeedsByFIdExist: false }
        }
      }
    ) {
      totalCount
    }
  }
`;

export const SYSTEM_MESSAGES_FROM_KATON = gql`
  query getSystemMessageFrom {
    getSystemMessageFrom {
      systemMessage
      totalCount
    }
  }
`;

export const READ_SYSTEM_MESSAGES = gql`
  mutation insertUserFeed($fId: UUID!, $uId: UUID!) {
    createUserFeed(input: { userFeed: { uId: $uId, fId: $fId } }) {
      clientMutationId
    }
  }
`;
